import * as React from 'react'
import { TextInput } from '../../TextInput'
import { FieldRenderProps } from 'react-final-form'

export const TextInputAdapter: React.SFC<FieldRenderProps> = ({
  input,
  meta,
  ...rest
}) => {
  return <TextInput {...meta} {...rest} {...input} />
}
